import { createContext, useContext } from 'react';

export const GASContext = createContext({});

export const useGAS = () => useContext(GASContext);
